import React from "react";
import { Link } from "react-router-dom";
import { Headline, Paragraph, Section, ContentBlock, Button } from "./ui";

const TextSection = ({
  margin = true,
  headline,
  lead,
  text,
  className = "",
  showButtons = false,
  primaryButton = null,
  secondaryButton = null,
  whatsappButton = false,
  whatsappNumber = "4915756850714",
  whatsappText = "Jetzt über WhatsApp",
}) => {
  return (
    <Section
      variant="primary"
      spacing="spacious"
      className={className}
      margin={margin}
    >
      <ContentBlock maxWidth="4xl" className="mx-auto">
        <Headline variant="h2" color="secondary" className="text-left mb-8">
          {headline}
        </Headline>
        {lead && (
          <Paragraph
            variant="lead"
            color="secondary"
            className="text-left mb-8"
          >
            {lead}
          </Paragraph>
        )}
        {text && (
          <Paragraph
            variant="medium"
            color="secondary"
            className="text-left max-w-3xl"
          >
            {text}
          </Paragraph>
        )}

        {/* Buttons Section */}
        {showButtons &&
          (primaryButton || secondaryButton || whatsappButton) && (
            <div className="flex flex-col sm:flex-row gap-4 mt-12">
              {whatsappButton && (
                <Button
                  as="a"
                  href={`https://wa.me/${whatsappNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="secondary"
                  size="xl"
                >
                  {whatsappText}
                </Button>
              )}

              {primaryButton && (
                <Button
                  onClick={primaryButton.onClick}
                  as={primaryButton.to ? Link : primaryButton.as || "button"}
                  href={primaryButton.href}
                  to={primaryButton.to}
                  target={primaryButton.target}
                  rel={primaryButton.rel}
                  variant={primaryButton.variant || "primary"}
                  size={primaryButton.size || "xl"}
                >
                  {primaryButton.text}
                </Button>
              )}

              {secondaryButton && (
                <Button
                  onClick={secondaryButton.onClick}
                  as={
                    secondaryButton.to ? Link : secondaryButton.as || "button"
                  }
                  href={secondaryButton.href}
                  to={secondaryButton.to}
                  target={secondaryButton.target}
                  rel={secondaryButton.rel}
                  variant={secondaryButton.variant || "outline"}
                  size={secondaryButton.size || "xl"}
                >
                  {secondaryButton.text}
                </Button>
              )}
            </div>
          )}
      </ContentBlock>
    </Section>
  );
};

export default TextSection;
